function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "73.5,0.7 73.5,17 68,17 68,5.8 5.8,5.8 5.8,17 0.3,17 0.3,0.7 \t"
}), React.createElement("polygon", {
  className: "st0",
  points: "73.5,52 73.5,69.6 0.3,69.6 0.3,52 5.8,52 5.8,64.5 68,64.5 68,52 \t"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  transform: "matrix(1.0003 0 0 1 -0.4219 45.0479)",
  className: "st1 st2 st3"
}, "PRESSERAPP");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "svg-logo",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 70",
    style: {
      "enableBackground": "new 0 0 200 70"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/logo.06747f9d.svg";
export { SvgComponent as ReactComponent };